import { UUID } from '../common';
import { IDecaDocument } from './deca.model';

export const DECA_CHANGES_BLOCKED_SHIPPER_TAX_IDS: ReadonlySet<string> = new Set(['B10927515']);
export const DECA_CHANGES_UNLOCKED_CARRIER_TAX_IDS: ReadonlySet<string> = new Set(['B19318864']);

export const PROMOTIONAL_CREDITS_CAMPAIGN_END_DATE = new Date('2026-10-15T23:59:59.999Z');

export function isPromotionalCreditsCampaignActive(now: Date = new Date()): boolean {
  return now.getTime() < PROMOTIONAL_CREDITS_CAMPAIGN_END_DATE.getTime();
}

function normalizeTaxId(taxId?: string): string {
  return (taxId ?? '').trim().toUpperCase();
}

export function isDecaShipperTaxIdBlocked(taxId?: string): boolean {
  const normalizedTaxId = normalizeTaxId(taxId);

  if (!normalizedTaxId) {
    return false;
  }

  return DECA_CHANGES_BLOCKED_SHIPPER_TAX_IDS.has(normalizedTaxId);
}

export function isDecaCarrierTaxIdUnlocked(taxId?: string): boolean {
  const normalizedTaxId = normalizeTaxId(taxId);

  if (!normalizedTaxId) {
    return false;
  }

  return DECA_CHANGES_UNLOCKED_CARRIER_TAX_IDS.has(normalizedTaxId);
}

export function isDecaChangesBlockedForCarrier(document: IDecaDocument, userCompanyId: UUID): boolean {
  const isCarrier = document.carrier.id === userCompanyId;
  const isCreator = document.createdByCompanyId === userCompanyId;

  return (
    isCarrier &&
    !isCreator &&
    isDecaShipperTaxIdBlocked(document.shipper.taxId) &&
    !isDecaCarrierTaxIdUnlocked(document.carrier.taxId)
  );
}

export function isDecaServicePriorToTimestamp(document: IDecaDocument, timestamp: Date): boolean {
  const originDates = (document.segments ?? [])
    .map((segment) => segment.origin.date)
    .filter((date): date is Date => date !== undefined);

  if (originDates.length === 0) {
    return false;
  }

  const firstOriginDate = new Date(Math.min(...originDates.map((date) => date.getTime())));
  return firstOriginDate.getTime() < timestamp.getTime();
}
